import 'regenerator-runtime/runtime';
export { i as default } from './onboard-76e821ce.js';
import 'bignumber.js';
import 'ethers';
import '@authereum/starkware-wallet';
import '@authereum/starkware-provider';
import 'bnc-sdk';
import 'bowser';